export interface IOption {
  code: string;
  content: string;
  depth: number;
  sort: number;
  active: number;
  hasFillBlank?: boolean;
  options: IOption[]; // 级联题子选项
  description: string; // 描述
}

export interface FillBlank {
  attachCode: string;
  code: string;
  type: number;
  required: number;
}

export enum CascaderType {
  birth = 'BIRTH-YEAR',
  area = 'PY-AREA',
}
export interface IQuestion {
  code: string;
  title: string;
  description: string;
  sort: number;
  type: string;
  required: number;
  pageIndex: number;
  options: IOption[];
  fillBlank: FillBlank[];
  specType: CascaderType | string;
  hotCities?: { code: string; content: string }[];
}

export interface IPage {
  index: number;
  questions: IQuestion[];
  pageCode: string;
  prefix: string;
  hasQuestionIndex: boolean;
  endTime: number;
  suffix: string;
  icon: string;
  description: string;
  submitSuccess: string;
  startTime: number;
  prefixBtn: string;
  title: string;
  hasPrev: 0 | 1;
}

export interface IRule {
  type: string;
  targetCodes: string[];
  sourceCode: string;
  options: string[];
  scores: any[];
}

export interface IQuestionnaireData {
  code: string;
  title: string;
  description: string;
  icon: string;
  url: string;
  qrCode: string;
  prefix: string;
  prefixBtn: string;
  hasPrev: number;
  status: number;
  pages: IPage[];
  hasQuestionIndex: boolean;
  rules: IRule[];
}
interface IAnswerBase {
  code: string;
  content: string;
}
export interface IAnswerItem extends IAnswerBase {
  options?: IAnswerBase[];
  codeList?: string[];
  textList?: string[];
}
